export default "__VITE_ASSET__BU$0xgDN__"